
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144.3-.1c12.9 0 23.4 10.5 23.4 23.4v37h58.9v-37c0-12.9 10.5-23.4 23.4-23.4s23.4 10.5 23.4 23.4v37h58.9v-37c0-12.9 10.5-23.4 23.4-23.4s23.4 10.5 23.4 23.4v37h82.3c12.9 0 23.4 10.5 23.4 23.4v392.8c0 12.9-10.5 23.4-23.4 23.4H38.6c-12.9 0-23.4-10.5-23.4-23.4V83.9c0-12.9 10.5-23.4 23.4-23.4h82.3v-37c0-13 10.5-23.6 23.4-23.6zM62 107.3v345.9h376V107.3H62zm58.9 82.3c0-12.9 10.5-23.4 23.4-23.4h211.5c12.9 0 23.4 10.5 23.4 23.4S368.7 213 355.8 213H144.3c-12.9 0-23.4-10.5-23.4-23.4zm138.1 69c8.8 3.6 14.5 12.2 14.5 21.7v82.3h6.8c12.9 0 23.4 10.5 23.4 23.4 0 12.9-10.5 23.4-23.4 23.4h-60.4c-12.9 0-23.4-10.5-23.4-23.4 0-12.9 10.5-23.4 23.4-23.4h6.8V333c-8 2.4-17 .5-23.3-5.9-9.2-9.2-9.2-24 0-33.1l30.2-30.2c6.6-6.9 16.7-8.9 25.4-5.2z"}})])
          )
        }
      }
    